import {
    inject, provideAppInitializer
} from "@angular/core";
import {
    IAppOptions, MgdRoutes
} from "@shopliftr/common-ng";
import { AdminRoutingId } from "./common/enums/admin-routing-id";
import { IAppConfig } from "./common/interfaces/app-config";
import { environment } from "../environments/environment";
import { AppRouterService } from "./common/services/app-router.service";
import { APP_CONFIG } from "./common/constants/app-config-token";
import { AppService } from "./common/services/app.service";
import { MonitoringContextWorkflowService } from "./common/services/monitoring-context-workflow.service";
import { FeatureGroup } from "@shopliftr/common-js/shared";

export const APP_ROUTES: MgdRoutes = [
    {
        path: "",
        redirectTo: "dashboard",
        pathMatch: "full"
    },
    {
        path: "dashboard",
        loadComponent: () => import("./dashboard/views/dashboard/dashboard.component").then((m) => m.DashboardComponent),
        data: {
            breadcrumb: "Dashboard",
            routeId: AdminRoutingId.Dashboard,
            sidenavLink: {
                icon: "home",
                title: "Dashboard",
                tooltip: "Dashboard"
            }
        }
    },
    {
        path: "tasks",
        loadChildren: () => import("./task/task.feature-group").then((m) => m.TASK_ROUTES),
        data: {
            breadcrumb: "Tasks",
            routeId: AdminRoutingId.Tasks,
            childFeatureGroupId: FeatureGroup.AdminTaskManagement,
            sidenavLink: {
                icon: "assignment",
                title: "Tasks",
                tooltip: "Tasks",
                permissions: ["task-read"]
            }
        }
    },
    {
        path: "users",
        loadChildren: () => import("./user/user.feature-group").then((m) => m.USER_ROUTES),
        data: {
            breadcrumb: "Users",
            routeId: AdminRoutingId.Users,
            childFeatureGroupId: FeatureGroup.AdminUserManagement,
            sidenavLink: {
                icon: "people",
                title: "Users",
                tooltip: "Users",
                permissions: ["task-read"]
            }
        }
    },
    {
        path: "product-management",
        loadChildren: () => import("./product-management/product-management.feature-group").then((m) => m.ROUTES),
        data: {
            breadcrumb: "Products",
            routeId: AdminRoutingId.Product,
            childFeatureGroupId: FeatureGroup.AdminProductManagement,
            sidenavLink: {
                icon: "shopping_cart",
                title: "Products",
                tooltip: "Product Management",
                permissions: ["product-update"]
            }
        }
    },
    {
        path: "deal-search",
        loadChildren: () => import("./deal-search/deal-search.feature-group")
            .then((m) => m.DEAL_SEARCH_FEATURE_GROUP),
        data: {
            childFeatureGroupId: FeatureGroup.AdminDealSearch,
            routeId: AdminRoutingId.DealSearch,
            breadcrumb: "Deal Search",
            sidenavLink: {
                icon: "local_offer",
                title: "Deal Search",
                tooltip: "Deal Search",
                permissions: ["deal-search"]
            }
        }
    },
    {
        path: "api-key-management",
        loadChildren: () => import("./api-key-management/api-key-management.feature-group").then((m) => m.ROUTES),
        data: {
            breadcrumb: "API Keys",
            routeId: AdminRoutingId.ApiKeyManagement,
            childFeatureGroupId: FeatureGroup.AdminApiKeyManagement,
            sidenavLink: {
                icon: "vpn_key",
                title: "API Keys",
                tooltip: "API Keys",
                permissions: ["api-key-read", "team-read"]
            }
        }
    },
    {
        path: "keyword-management",
        loadChildren: () => import("./keyword-management/keyword-management.feature-group").then((m) => m.ROUTES),
        data: {
            breadcrumb: "Keywords",
            routeId: AdminRoutingId.KeywordManagement,
            childFeatureGroupId: FeatureGroup.AdminKeywordManagement,
            sidenavLink: {
                icon: "youtube_searched_for",
                title: "Keywords",
                tooltip: "Keywords",
                permissions: ["keyword-read"]
            }
        }
    },
    {
        path: "store-management",
        loadChildren: () => import("./store-management/store-management.feature-group").then((m) => m.ROUTES),
        data: {
            breadcrumb: "Store Management",
            routeId: AdminRoutingId.StoreManagement,
            childFeatureGroupId: FeatureGroup.AdminStoreManagement,
            sidenavLink: {
                icon: "store",
                title: "Store Management",
                tooltip: "Store Management",
                permissions: ["flyerVersion-read"]
            }
        }
    },
    {
        path: "getting-started",
        loadComponent: () => import("./getting-started/views/getting-started/getting-started.component").then((m) => m.GettingStartedComponent),
        data: {
            breadcrumb: "Getting Started",
            routeId: AdminRoutingId.GettingStarted,
            sidenavLink: {
                icon: "info",
                title: "Getting Started",
                tooltip: "Getting Started",
                permissions: ["deal-create"]
            }
        }
    },
];

export const APP_OPTIONS: IAppOptions<IAppConfig> = {

    config: environment,
    configInjectionToken: APP_CONFIG,
    appRouterService: AppRouterService,
    appService: AppService,
    routes: APP_ROUTES,
    useLocalizations: true,
    additionalProviders: [provideAppInitializer(() => inject(MonitoringContextWorkflowService).start())]
};
